import { FormFieldProps } from "src/utils/types/inputTypes";

export const interestConditionsFields: FormFieldProps[] = [
  {
    type: "textField",
    label: "Úroková sazba z vkladů (roční v %)",
    name: "interest",
  },
];
